import { render, staticRenderFns } from "./FloatingHelpdeskWidget.vue?vue&type=template&id=ac058a86&scoped=true"
import script from "./FloatingHelpdeskWidget.vue?vue&type=script&lang=js"
export * from "./FloatingHelpdeskWidget.vue?vue&type=script&lang=js"
import style0 from "./FloatingHelpdeskWidget.vue?vue&type=style&index=0&id=ac058a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac058a86",
  null
  
)

export default component.exports